import { useState } from 'react';
import gettext from '@sdk/lang/gettext';

import { PathnameEnum } from '@web/Router/router.types';
import { generatePath } from '@web/Router/router.utils';
import { useConversationCreateRestrictions } from '@web/conversations/ComposeConversation/composeConversation.hooks';
import { GroupConversationsSection } from '@web/conversations/ConversationsSidebar/components/GroupConversationsTitle/GroupConversationsSection';

import { ArchivedGroup } from './components/ArchivedGroup/ArchivedGroup';
import { Group } from './components/Group/Group';
import { SearchForm } from './components/SearchForm/SearchForm';
import { useConversationGroups } from './conversationsSidebar.hooks';
import {
  Footer,
  Header,
  Sections,
  StartConversationLink,
  Wrapper,
} from './conversationsSidebar.styles';

export const ConversationsSidebar = () => {
  const [filterQuery, setFilterQuery] = useState('');
  const { groups, isLoading } = useConversationGroups(filterQuery);
  const {
    canOnlyStartPrivateConversation,
    canStartGroupConversation,
    canStartPrivateConversation,
  } = useConversationCreateRestrictions();

  if (isLoading) {
    return null;
  }

  return (
    <Wrapper>
      <Header>
        {(canStartGroupConversation || canStartPrivateConversation) && (
          <StartConversationLink
            to={generatePath(
              canOnlyStartPrivateConversation
                ? PathnameEnum.CONVERSATION_COMPOSE_PRIVATE
                : PathnameEnum.CONVERSATION_COMPOSE
            )}>
            {gettext('Start conversation')}
          </StartConversationLink>
        )}

        <SearchForm onFilterQueryChange={setFilterQuery} />
      </Header>

      <Sections>
        <GroupConversationsSection
          items={groups.group}
          canStartGroupConversation={canStartGroupConversation}
        />

        <Group
          createPath={
            canStartPrivateConversation ? PathnameEnum.CONVERSATION_COMPOSE_PRIVATE : undefined
          }
          items={groups.private}
          title={gettext('Private conversations')}
        />
      </Sections>

      <Footer>{groups.archived.length > 0 && <ArchivedGroup items={groups.archived} />}</Footer>
    </Wrapper>
  );
};
